import banner from "@/store/banner";
import Vuex from "vuex";
import { i18n, setI18nLanguage } from "@/i18n";
import VeeValidate, { Validator } from "vee-validate";
import validatorEs from "@/validator/es";
import validatorEn from "@/validator/en";
import axios from "axios";

const store = new Vuex.Store({
  state: {
    language: null,
    server: "https://back.ajusa.es/",
    likes: JSON.parse(localStorage.getItem("likes")) || new Array(),
    hints: JSON.parse(localStorage.getItem("hints")) || new Array(),
    validators: {
      es: validatorEs,
      en: validatorEn
    },
    videos: null,
    popup: true,
    tips: [],
    currentTips: [],
    categories: []
  },
  getters: {
    getLanguage: state => state.language,
    getPopup: state => state.popup,
    getServer: state => state.server,
    getlike(state) {
      return slug => {
        return state.likes.some(l => l == slug);
      };
    },
    gethint(state) {
      return slug => {
        return state.hints.some(l => l == slug);
      };
    },
    getVideos(state) {
      return state.videos;
    },
    getTips: state => state.tips
  },
  actions: {
    changeLanguage: ({ commit, state }, changeTo) => {
      return new Promise((resolve, reject) => {
        commit("setLanguage", changeTo);
        setI18nLanguage(changeTo);
        Validator.localize(
          "es",
          state.validators[changeTo]
            ? state.validators[changeTo]
            : state.validators["en"]
        );
        document.documentElement.setAttribute("lang", i18n.t("isotag"));

        resolve(changeTo);
      });
    },
    sendLike: ({ commit }, slug) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`like/${slug}`)
          .then(response => {
            resolve(response.data.likes);
            commit("addLike", slug);
          })
          .catch(function(error) {
            reject(false);
          });
      });
    },
    sendHint: ({ commit }, slug) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`hint/${slug}`)
          .then(response => {
            resolve(response.data.hints);
            commit("addHint", slug);
          })
          .catch(function(error) {
            reject(false);
          });
      });
    },
    setVideos({ commit }) {
      if (this.state.videos) {
        return;
      }

      return new Promise((resolve, reject) => {
        axios
          .get("https://dmb.ajusa.online/api/youtube")
          .then(result => {
            if (result.data.items) {
              resolve(result.data.items);
              commit("addVideos", result.data.items);
            } else {
              commit("addVideos", [
                {
                  kind: "youtube#searchResult",
                  etag: "D9UUxz7aPDwsWrv6E6oIEDI2Zic",
                  id: {
                    kind: "youtube#video",
                    videoId: "Zxc_tnbaYjk"
                  },
                  snippet: {
                    publishedAt: "2025-04-21T07:14:40Z",
                    channelId: "UCnoYVeFbsPiOVOcf80tW6Bg",
                    title:
                      "Watch This Before Replacing Your Peugeot Head Gasket! #peugeotrifter #ajusa",
                    description:
                      "FULL VIDEO: https://www.youtube.com/watch?v=cgUOKzmnT5w #PeugeotRifter.",
                    thumbnails: {
                      default: {
                        url: "https://i.ytimg.com/vi/Zxc_tnbaYjk/default.jpg",
                        width: 120,
                        height: 90
                      },
                      medium: {
                        url: "https://i.ytimg.com/vi/Zxc_tnbaYjk/mqdefault.jpg",
                        width: 320,
                        height: 180
                      },
                      high: {
                        url: "https://i.ytimg.com/vi/Zxc_tnbaYjk/hqdefault.jpg",
                        width: 480,
                        height: 360
                      }
                    },
                    channelTitle: "Ajusa",
                    liveBroadcastContent: "none",
                    publishTime: "2025-04-21T07:14:40Z"
                  }
                },
                {
                  kind: "youtube#searchResult",
                  etag: "MERiO4Ngw0N7EOjSrWapOh3SSBs",
                  id: {
                    kind: "youtube#video",
                    videoId: "cgUOKzmnT5w"
                  },
                  snippet: {
                    publishedAt: "2025-04-14T17:30:06Z",
                    channelId: "UCnoYVeFbsPiOVOcf80tW6Bg",
                    title:
                      "PEUGEOT RIFTER Blue HDI | #Ajusa | Auto parts / Componentes del motor",
                    description:
                      "(ES) Aprender de mecánica es muy fácil con los vídeos de Ajusa. En este vídeo, te mostramos cómo realizar el montaje de la ...",
                    thumbnails: {
                      default: {
                        url: "https://i.ytimg.com/vi/cgUOKzmnT5w/default.jpg",
                        width: 120,
                        height: 90
                      },
                      medium: {
                        url: "https://i.ytimg.com/vi/cgUOKzmnT5w/mqdefault.jpg",
                        width: 320,
                        height: 180
                      },
                      high: {
                        url: "https://i.ytimg.com/vi/cgUOKzmnT5w/hqdefault.jpg",
                        width: 480,
                        height: 360
                      }
                    },
                    channelTitle: "Ajusa",
                    liveBroadcastContent: "none",
                    publishTime: "2025-04-14T17:30:06Z"
                  }
                },
                {
                  kind: "youtube#searchResult",
                  etag: "kDSHdURelWoLeaHkEpy72UA1TTc",
                  id: {
                    kind: "youtube#video",
                    videoId: "eaGMWDMV8ew"
                  },
                  snippet: {
                    publishedAt: "2025-04-08T11:49:07Z",
                    channelId: "UCnoYVeFbsPiOVOcf80tW6Bg",
                    title: "Juntas culata #Ajusa",
                    description:
                      "Lista para llegar a tus manos y rendir al máximo. Desde el control de calidad hasta el emblistado final, nos aseguramos de que ...",
                    thumbnails: {
                      default: {
                        url: "https://i.ytimg.com/vi/eaGMWDMV8ew/default.jpg",
                        width: 120,
                        height: 90
                      },
                      medium: {
                        url: "https://i.ytimg.com/vi/eaGMWDMV8ew/mqdefault.jpg",
                        width: 320,
                        height: 180
                      },
                      high: {
                        url: "https://i.ytimg.com/vi/eaGMWDMV8ew/hqdefault.jpg",
                        width: 480,
                        height: 360
                      }
                    },
                    channelTitle: "Ajusa",
                    liveBroadcastContent: "none",
                    publishTime: "2025-04-08T11:49:07Z"
                  }
                }
              ]);
            }
          })
          .catch(e => {
            commit("addVideos", [
              {
                kind: "youtube#searchResult",
                etag: "D9UUxz7aPDwsWrv6E6oIEDI2Zic",
                id: {
                  kind: "youtube#video",
                  videoId: "Zxc_tnbaYjk"
                },
                snippet: {
                  publishedAt: "2025-04-21T07:14:40Z",
                  channelId: "UCnoYVeFbsPiOVOcf80tW6Bg",
                  title:
                    "Watch This Before Replacing Your Peugeot Head Gasket! #peugeotrifter #ajusa",
                  description:
                    "FULL VIDEO: https://www.youtube.com/watch?v=cgUOKzmnT5w #PeugeotRifter.",
                  thumbnails: {
                    default: {
                      url: "https://i.ytimg.com/vi/Zxc_tnbaYjk/default.jpg",
                      width: 120,
                      height: 90
                    },
                    medium: {
                      url: "https://i.ytimg.com/vi/Zxc_tnbaYjk/mqdefault.jpg",
                      width: 320,
                      height: 180
                    },
                    high: {
                      url: "https://i.ytimg.com/vi/Zxc_tnbaYjk/hqdefault.jpg",
                      width: 480,
                      height: 360
                    }
                  },
                  channelTitle: "Ajusa",
                  liveBroadcastContent: "none",
                  publishTime: "2025-04-21T07:14:40Z"
                }
              },
              {
                kind: "youtube#searchResult",
                etag: "MERiO4Ngw0N7EOjSrWapOh3SSBs",
                id: {
                  kind: "youtube#video",
                  videoId: "cgUOKzmnT5w"
                },
                snippet: {
                  publishedAt: "2025-04-14T17:30:06Z",
                  channelId: "UCnoYVeFbsPiOVOcf80tW6Bg",
                  title:
                    "PEUGEOT RIFTER Blue HDI | #Ajusa | Auto parts / Componentes del motor",
                  description:
                    "(ES) Aprender de mecánica es muy fácil con los vídeos de Ajusa. En este vídeo, te mostramos cómo realizar el montaje de la ...",
                  thumbnails: {
                    default: {
                      url: "https://i.ytimg.com/vi/cgUOKzmnT5w/default.jpg",
                      width: 120,
                      height: 90
                    },
                    medium: {
                      url: "https://i.ytimg.com/vi/cgUOKzmnT5w/mqdefault.jpg",
                      width: 320,
                      height: 180
                    },
                    high: {
                      url: "https://i.ytimg.com/vi/cgUOKzmnT5w/hqdefault.jpg",
                      width: 480,
                      height: 360
                    }
                  },
                  channelTitle: "Ajusa",
                  liveBroadcastContent: "none",
                  publishTime: "2025-04-14T17:30:06Z"
                }
              },
              {
                kind: "youtube#searchResult",
                etag: "kDSHdURelWoLeaHkEpy72UA1TTc",
                id: {
                  kind: "youtube#video",
                  videoId: "eaGMWDMV8ew"
                },
                snippet: {
                  publishedAt: "2025-04-08T11:49:07Z",
                  channelId: "UCnoYVeFbsPiOVOcf80tW6Bg",
                  title: "Juntas culata #Ajusa",
                  description:
                    "Lista para llegar a tus manos y rendir al máximo. Desde el control de calidad hasta el emblistado final, nos aseguramos de que ...",
                  thumbnails: {
                    default: {
                      url: "https://i.ytimg.com/vi/eaGMWDMV8ew/default.jpg",
                      width: 120,
                      height: 90
                    },
                    medium: {
                      url: "https://i.ytimg.com/vi/eaGMWDMV8ew/mqdefault.jpg",
                      width: 320,
                      height: 180
                    },
                    high: {
                      url: "https://i.ytimg.com/vi/eaGMWDMV8ew/hqdefault.jpg",
                      width: 480,
                      height: 360
                    }
                  },
                  channelTitle: "Ajusa",
                  liveBroadcastContent: "none",
                  publishTime: "2025-04-08T11:49:07Z"
                }
              }
            ]);
            reject(e);
          });
      });
    },
    changePopup({ state }, status) {
      state.popup = status;
    },
    fetchTips({ commit, state }, lang) {
      return new Promise((resolve, reject) => {
        axios
          .get(`tips-new?lang=${lang}`)
          .then(response => {
            commit("setTips", response.data.tips);
            const weekBefore = new Date();
            weekBefore.setDate(new Date().getDate() - 7);
            const tips = response.data.tips.filter(tip => {
              return new Date(tip.creado).getTime() > weekBefore.getTime();
            });
            state.currentTips = tips;
            state.categories = response.data.categories;
            resolve(response.data.tips);
          })
          .catch(error => console.log(error));
      });
    }
  },
  mutations: {
    setLanguage(state, lang) {
      state.language = lang;
    },
    addLike(state, slug) {
      state.likes.push(slug);
      window.localStorage.setItem("likes", JSON.stringify(state.likes));
    },
    addHint(state, slug) {
      state.hints.push(slug);
      window.localStorage.setItem("hints", JSON.stringify(state.hints));
    },
    addVideos(state, videos) {
      state.videos = videos;
    },
    setTips(state, tips) {
      state.tips = tips;
    }
  },
  modules: {
    banner
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js